const sitemaps = [
	"state_sitemap",
	"city_sitemap",
	"article_sitemap",
	"city_service_sitemap",
	"costguide_sitemap",
	"profile_sitemap",
	"service_sitemap",
	"sitemap",
];
const pages = 10;

let sitemapString = "";
for (let z = 0; z < sitemaps.length; z++) {
	sitemapString += z === 0 ? `${sitemaps[z]}` : `|${sitemaps[z]}`;
	for (let i = 0; i < pages; i++) {
		sitemapString += `|${sitemaps[z]}_list_${i}`;
	}
}
export default [
	{
		path: "/near-me",
		exact: true,
		ssr: true,
		seo: true,
		component: "NearMe/NearMe",
	},
	/* 	{
		path: "/sitemap/locations",
		exact: true,
		ssr: true,
seo: true,
		component: "Locations/Locations",
	},
	{
		path: "/sitemap/profiles",
		exact: true,
		ssr: true,
seo: true,
		component: "Profiles/Profiles",
	}, */
	{
		path: `/:name(${sitemapString}).xml`,
		exact: true,
		ssr: true,
		seo: true,
		component: "Xml/Xml",
	},
];
